import { render } from "./thong-tin-thanh-toan.vue?vue&type=template&id=c84dbb5c&scoped=true"
import script from "./thong-tin-thanh-toan.vue?vue&type=script&lang=js"
export * from "./thong-tin-thanh-toan.vue?vue&type=script&lang=js"

import "./thong-tin-thanh-toan.vue?vue&type=style&index=0&id=c84dbb5c&lang=scss&scoped=true"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c84dbb5c"]])

export default __exports__